import React from 'react';
import { Image } from '@cian/ui-kit';

import styles from './styles.css';

export type BankLogoListProps = {
  banks: string[];
};

export const BankLogoList: React.FC<BankLogoListProps> = ({ banks }) => {
  //TODO проконтролировать вывод при выкатке банков от бэка
  return (
    <div className={styles['root']}>
      {banks.map((logo, index) => (
        <div key={index} className={styles['logo']}>
          <Image src={logo} alt={''} preloader />
        </div>
      ))}
    </div>
  );
};

BankLogoList.displayName = 'BankLogoList';
